import { IPromise } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import { IAllUserCount, IAllUserCountRes } from './user.interface';
import { ApiService } from '../api-service/api.service';
import { User } from '../../entities/user';
import { IUploadFileResult } from '../../interfaces/upload-file-response.interface';
import { isObject } from 'lodash-es';
import { IEssentialInfo } from '../../entities/profile';
import {
  IProjectConfig,
  PROJECT_CONFIG
} from '../../constants/project-config.constant';
import { IUserDailyReport } from './user.daily-report';

export class UserService {
  static $inject = ['GmcApi', 'ApiService', PROJECT_CONFIG];

  constructor(
    private gmcApi: GmcApi,
    private apiService: ApiService,
    private projectConfig: IProjectConfig
  ) {}

  getUsersCount(): IPromise<IAllUserCount> {
    return this.apiService
      .get<IAllUserCountRes>('/user/getUsersCounters')
      .then((data) => {
        const counters = data.usersCounters;
        const parsedCounters: IAllUserCount = {};
        Object.keys(counters).forEach((key) => {
          parsedCounters[key] = parseInt(counters[key], 10);
        });
        return parsedCounters;
      });
  }

  getMilestone(): IPromise<any[]> {
    return this.apiService.get<any>('/pages/all/getUserCounterByDateWeb');
  }

  getCandidatePosition(): IPromise<any> {
    return this.apiService.get<any>('/user/getCandidatePosition');
  }

  getUserActiveServices() {
    return this.apiService.get<any>('/services/count');
  }

  /*getUsersOnline(): IPromise<IUserCounterOnline[]> {
    return this.$http.get<any>(this.gmcApi.helpers.getUsersCounters)
      .then(( res ) => {
        return res.data.online;
      });
  }*/

  getUserById(id?: string): IPromise<User> {
    return this.apiService.get('/user', { params: { id } }).then((userData) => {
      const user = new User(userData);
      user.photo = user.photo || this.projectConfig.defaultPhoto;
      return user;
    });
  }

  updatePhoto(file: File): IPromise<string> {
    return this.apiService
      .upload<IUploadFileResult>('/user/saveFile/avatar', { file })
      .then((res) => {
        const uploadResult: IUploadFileResult = res.data;
        if (isObject(uploadResult) && !uploadResult.isError) {
          const update = {
            photo: uploadResult.url
          };
          return this.apiService
            .post('/user/updateBasicProfile', { personal_info: update })
            .then(() => uploadResult.url);
        } else {
          throw res;
        }
      });
  }

  updateEssentialInfo(data: IEssentialInfo): IPromise<any> {
    const update = {
      personal_info: {
        essentialInfo: data
      }
    };
    return this.apiService.post('/user/updateBasicProfile', update);
  }

  deleteUser(username: string, password: string): IPromise<any> {
    return this.apiService.request<any>({
      method: 'DELETE',
      url: '/user/deleteMyProfile',
      data: { username: username, password },
      headers: { 'Content-Type': 'application/json' }
    });
  }

  getUsersCountersWithOnline(): IPromise<any> {
    return this.apiService
      .get('/pages/all/getUsersCountersWithOnline');
  }

  getDailyReport(): IPromise<IUserDailyReport> {
    return this.apiService.get('/user/dailyReport').then((data) => {
      return data.data;
    });
  }

  getMyReferalStatsByCountries(): IPromise<any> {
    return this.apiService
      .get('/user/getMyReferalStatsByCountries')
      .then((res) => {
        return res;
      });
  }
}



// WEBPACK FOOTER //
// ./app/core/services/user/user.service.ts